import { render, staticRenderFns } from "./hs-select.vue?vue&type=template&id=18b40a5c&scoped=true&"
import script from "./hs-select.vue?vue&type=script&lang=js&"
export * from "./hs-select.vue?vue&type=script&lang=js&"
import style0 from "./hs-select.vue?vue&type=style&index=0&id=18b40a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b40a5c",
  null
  
)

export default component.exports